import React from 'react';

export const EmailComposed = ({ width = 20, height = 20, className = '' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_12682_1261455)">
      <path
        d="M16.666 10.4173V5.83398C16.666 5.61297 16.5782 5.40107 16.4219 5.24479C16.2656 5.08851 16.0537 5.00065 15.8327 5.00065H4.16602C3.945 5.00065 3.7331 5.08851 3.57682 5.24479C3.42054 5.40107 3.33268 5.61297 3.33268 5.83398V14.1673C3.33268 14.3883 3.42054 14.6002 3.57682 14.7565C3.7331 14.9128 3.945 15.0007 4.16602 15.0007H9.99935C10.4596 15.0007 10.8327 15.3737 10.8327 15.834C10.8327 16.2942 10.4596 16.6673 9.99935 16.6673H4.16602C3.50297 16.6673 2.86728 16.4037 2.39844 15.9349C1.9296 15.4661 1.66602 14.8304 1.66602 14.1673V5.83398C1.66602 5.17094 1.9296 4.53525 2.39844 4.06641C2.86728 3.59757 3.50297 3.33398 4.16602 3.33398H15.8327C16.4957 3.33398 17.1314 3.59757 17.6003 4.06641C18.0691 4.53525 18.3327 5.17094 18.3327 5.83398V10.4173C18.3327 10.8776 17.9596 11.2507 17.4993 11.2507C17.0391 11.2507 16.666 10.8776 16.666 10.4173Z"
        fill="#10B981"
      />
      <path
        d="M15 18.3333V13.3333C15 12.8731 15.3731 12.5 15.8333 12.5C16.2936 12.5 16.6667 12.8731 16.6667 13.3333V18.3333C16.6667 18.7936 16.2936 19.1667 15.8333 19.1667C15.3731 19.1667 15 18.7936 15 18.3333Z"
        fill="#10B981"
      />
      <path
        d="M17.7441 15.2441C18.0695 14.9186 18.597 14.9186 18.9225 15.2441C19.2479 15.5695 19.2479 16.097 18.9225 16.4225L16.4225 18.9225C16.097 19.2479 15.5695 19.2479 15.2441 18.9225L12.7441 16.4225C12.4186 16.097 12.4186 15.5695 12.7441 15.2441C13.0695 14.9186 13.597 14.9186 13.9225 15.2441L15.8333 17.1549L17.7441 15.2441Z"
        fill="#10B981"
      />
      <path
        d="M17.0372 5.14005C17.4201 4.88475 17.9375 4.98823 18.1928 5.37117C18.4481 5.75411 18.3446 6.27147 17.9617 6.52677L10.4617 11.5268C10.1817 11.7134 9.8171 11.7134 9.53718 11.5268L2.03718 6.52677C1.65424 6.27147 1.55077 5.75411 1.80606 5.37117C2.06136 4.98823 2.57872 4.88475 2.96166 5.14005L9.99942 9.83162L17.0372 5.14005Z"
        fill="#10B981"
      />
    </g>
    <defs>
      <clipPath id="clip0_12682_1261455">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
